import { AppTypeEnum } from "@verbleif/lib/src/composables/Api/Type/AppStore/app.enum";

/**
 * Pure type-level test with no permission semantics: true for every outbound app regardless of who's
 * asking or which shell renders it. The single source of truth for "is this app outbound" so call sites
 * never repeat the `app.type === AppTypeEnum.OUTBOUND` magic comparison. Shared by the requested-
 * permissions empty state (outbound apps never request scopes: they have no `requestedScopes` concept),
 * the allowed return origins (only an outbound app's partner hands over a returnUrl) and
 * `isOutboundAppEditRestrictedOnWeb`. Kept free of stores so the app form transformer can use it.
 */
export function isOutboundApp(app: { type?: AppTypeEnum | null } | null | undefined): boolean {
  return app?.type === AppTypeEnum.OUTBOUND;
}
